/**
 * 設定の画面の頭（#156、docs/65 §2。#153〜#155 の画面と同じ形を1つにした）：上の帯「‹ 前の画面｜右の動き」と大きな題。
 *   ・PC の2列の右で、左の列に行がある画面（pane.top）は「‹ 設定」を出さず、右の動き（招待・編集・保存）は題の右に置く（docs/62 §6）
 *   ・下の画面（言葉の1語・帳票ごと）とスマホ版は上の帯を出す（「‹ 言葉の言い換え｜保存」）
 * 見た目は styles.css の .cotop・.ptitle-row（#151〜#153）
 */
import type { ReactNode } from "react";
import { useSettingsPane } from "../lib/settingsPane.js";
import { BackButton, type BackNav } from "./BackButton.jsx";

export function SettingsHead({ back, title, end, titleTestId, list = false }: { back: BackNav; title: ReactNode; /** 右の動き（藍の文字だけのボタン） */ end?: ReactNode; titleTestId?: string | undefined; /** 一覧の上にシートが開く画面（/settings/users/new・/:id でも一覧は左の列の行の画面＝「‹ 設定」を出さない） */ list?: boolean }) {
  const pane0 = useSettingsPane();
  const pane = list && pane0.twoCol ? { ...pane0, top: true } : pane0;
  return (
    <>
      {pane.top ? null : (
        <div className="cotop">
          <BackButton back={back} />
          <span className="cotop-sp" />
          {end}
        </div>
      )}
      {back.dialog}
      <div className="ptitle-row">
        <h1 className="ptitle" data-testid={titleTestId}>
          {title}
        </h1>
        {pane.top ? end : null}
      </div>
    </>
  );
}

/** 画面の外側の class（.ppage＝個人設定と同じ列、PC の2列の右は 600px＝.restpage） */
export function useRestPageClass(extra?: string): string {
  const pane = useSettingsPane();
  return "ppage restpage" + (extra ? ` ${extra}` : "") + (pane.twoCol ? " is-pane" : "");
}
